import '@availity/yup';
import * as yup from 'yup';

// //https://gist.githubusercontent.com/stephenway/19f46c2dca4cca601ed296e1ceeaec3d/raw/1073dbe434554b293a6bc04c283b57b8e64573ff/uniqueValidationMethod.js
// yup.addMethod(yup.array, 'unique', function (message, mapper = (a) => a) {
//   return this.test('unique', message, function (list) {
//     if (!Array.isArray(list)) return true;
//     return list.length === new Set(list.map(mapper)).size;
//   });
// });

const formValidation = yup.object().shape({
  title: yup.string().required(),
  published: yup
    .boolean()
    .transform((value, originalValue) => (originalValue ? true : false)),
  buttonTimeline: yup.string().nullable(),
  buttonTimelineTitle: yup
    .string()
    .label('button timeline title')
    .when('buttonTimeline', {
      is: (value) => value === 'sx-timeline',
      then: () => yup.string().required(),
      otherwise: () => yup.string(),
    }),
  ballonTags: yup.array().of(
    yup.object({
      order: yup.number().label('ballon tag order').required().min(1).max(8),
      title: yup.string().label('ballon tag title').required(),
    }),
  ),
  //.unique('duplicate order', (a) => a.order),
});

export default formValidation;
